// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * AppModal.css — Professional modal styles
 * Portal-based: always above navbar, sidebar, and any fixed element.
 */

/* ── Overlay ─────────────────────────────────────────────────────────────── */
.am-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 20, 38, 0.62);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;          /* Way above navbar (1030), sidebar (950), everything */
  padding: 1rem;
  animation: am-fade-in 0.15s ease;
}

@keyframes am-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ── Dialog ──────────────────────────────────────────────────────────────── */
.am-dialog {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.25),
    0 20px 60px rgba(0, 0, 0, 0.6);
  width: 100%;
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: am-slide-in 0.2s cubic-bezier(0.34, 1.10, 0.64, 1);
}

@keyframes am-slide-in {
  from { transform: translateY(-18px) scale(0.97); opacity: 0; }
  to   { transform: translateY(0)     scale(1);    opacity: 1; }
}

/* Sizes */
.am-dialog--sm { max-width: 480px; }
.am-dialog--md { max-width: 640px; }
.am-dialog--lg { max-width: 860px; }
.am-dialog--xl { max-width: 1080px; }

/* ── Header ──────────────────────────────────────────────────────────────── */
.am-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem 1rem 1.5rem;
  background: linear-gradient(120deg, #1e1b4b 0%, #312e81 60%, #4338ca 100%);
  flex-shrink: 0;
  gap: 0.75rem;
  border-bottom: 1px solid var(--slate-300);
}

.am-header-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.am-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #f0f6ff;
  letter-spacing: 0.01em;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.am-subtitle {
  margin: 0;
  font-size: 0.78rem;
  color: rgba(210, 230, 255, 0.75);
  line-height: 1.2;
}

.am-close {
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  padding: 0;
}

.am-close:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

/* ── Body ────────────────────────────────────────────────────────────────── */
.am-body {
  flex: 1 1;
  padding: 1.5rem;
  overflow-y: auto;
  overflow-x: hidden;
}

/* ── Footer ──────────────────────────────────────────────────────────────── */
.am-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
  background: var(--bg-toolbar);
  flex-shrink: 0;
}

/* ── Form grid helper (use inside am-body) ──────────────────────────────── */
.am-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

.am-form-grid--1 { grid-template-columns: 1fr; }
.am-form-grid--3 { grid-template-columns: 1fr 1fr 1fr; }
.am-col-full     { grid-column: 1 / -1; }

.am-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.am-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.am-label .required { color: #dc3545; margin-left: 2px; }

.am-input,
.am-select,
.am-textarea {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1.5px solid var(--slate-300);
  border-radius: 7px;
  font-size: 0.9rem;
  font-family: inherit;
  color: var(--text-primary);
  background: var(--bg-input);
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
}

.am-input:focus,
.am-select:focus,
.am-textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2);
}

.am-input::placeholder { color: var(--text-muted); }

.am-textarea { resize: vertical; min-height: 72px; }

/* Section divider inside form */
.am-section {
  grid-column: 1 / -1;
  padding: 0.5rem 0 0.25rem;
  margin-top: 0.25rem;
  border-top: 1px solid var(--border);
}

.am-section-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

/* ── Action buttons (use in am-footer) ──────────────────────────────────── */
.am-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1.1rem;
  border: none;
  border-radius: 7px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  letter-spacing: 0.01em;
}

.am-btn:active  { transform: scale(0.97); }
.am-btn:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }

.am-btn-primary {
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: #fff;
  box-shadow: 0 2px 8px rgba(var(--accent-rgb),.3);
}
.am-btn-primary:hover:not(:disabled) { background: linear-gradient(135deg, var(--accent-l), var(--accent)); }

.am-btn-secondary {
  background: var(--bg-input);
  color: var(--text-secondary);
  border: 1px solid var(--slate-300);
}
.am-btn-secondary:hover:not(:disabled) { background: var(--slate-300); color: var(--text-primary); }

.am-btn-danger {
  background: #dc3545;
  color: #fff;
}
.am-btn-danger:hover:not(:disabled) { background: #c82333; }

/* Alert inside modal */
.am-alert {
  padding: 0.7rem 1rem;
  border-radius: 7px;
  font-size: 0.88rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}
.am-alert-danger  { background: rgba(220,38,38,.1); border: 1px solid rgba(220,38,38,.25); color: #f87171; }
.am-alert-warning { background: rgba(245,158,11,.08); border: 1px solid rgba(245,158,11,.2); color: #fcd34d; }
.am-alert-info    { background: rgba(var(--accent-rgb),.1); border: 1px solid rgba(var(--accent-rgb),.25); color: #a5b4fc; }

/* ── Responsive ──────────────────────────────────────────────────────────── */
@media (max-width: 600px) {
  .am-dialog { border-radius: 10px 10px 0 0; }
  .am-overlay { align-items: flex-end; padding: 0; }
  .am-dialog--sm,
  .am-dialog--md,
  .am-dialog--lg,
  .am-dialog--xl { max-width: 100%; }
  .am-form-grid { grid-template-columns: 1fr; }
  .am-form-grid--3 { grid-template-columns: 1fr 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,+EAA+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,WAAW,uDAAuD;EAC/E,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,+EAA+E;AAC/E;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB;;kCAEgC;EAChC,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,OAAO,wCAAwC,EAAE,UAAU,EAAE;EAC7D,OAAO,qCAAqC,KAAK,UAAU,EAAE;AAC/D;;AAEA,UAAU;AACV,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,iBAAiB,EAAE;;AAEpC,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,0EAA0E;EAC1E,cAAc;EACd,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA,mBAAmB,0BAA0B,EAAE;AAC/C,mBAAmB,kCAAkC,EAAE;AACvD,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;;AAExD;;;EAGE,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,yBAAyB,wBAAwB,EAAE;;AAEnD,eAAe,gBAAgB,EAAE,gBAAgB,EAAE;;AAEnD,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA,kBAAkB,sBAAsB,EAAE;AAC1C,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAExE;EACE,sEAAsE;EACtE,WAAW;EACX,gDAAgD;AAClD;AACA,uCAAuC,mEAAmE,EAAE;;AAE5G;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;AACA,yCAAyC,4BAA4B,EAAE,0BAA0B,EAAE;;AAEnG;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,sCAAsC,mBAAmB,EAAE;;AAE3D,uBAAuB;AACvB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA,oBAAoB,8BAA8B,EAAE,qCAAqC,EAAE,cAAc,EAAE;AAC3G,oBAAoB,gCAAgC,EAAE,qCAAqC,EAAE,cAAc,EAAE;AAC7G,oBAAoB,sCAAsC,EAAE,6CAA6C,EAAE,cAAc,EAAE;;AAE3H,+EAA+E;AAC/E;EACE,aAAa,4BAA4B,EAAE;EAC3C,cAAc,qBAAqB,EAAE,UAAU,EAAE;EACjD;;;mBAGiB,eAAe,EAAE;EAClC,gBAAgB,0BAA0B,EAAE;EAC5C,mBAAmB,8BAA8B,EAAE;AACrD","sourcesContent":["/*\r\n * AppModal.css — Professional modal styles\r\n * Portal-based: always above navbar, sidebar, and any fixed element.\r\n */\r\n\r\n/* ── Overlay ─────────────────────────────────────────────────────────────── */\r\n.am-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(10, 20, 38, 0.62);\r\n  backdrop-filter: blur(3px);\r\n  -webkit-backdrop-filter: blur(3px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9000;          /* Way above navbar (1030), sidebar (950), everything */\r\n  padding: 1rem;\r\n  animation: am-fade-in 0.15s ease;\r\n}\r\n\r\n@keyframes am-fade-in {\r\n  from { opacity: 0; }\r\n  to   { opacity: 1; }\r\n}\r\n\r\n/* ── Dialog ──────────────────────────────────────────────────────────────── */\r\n.am-dialog {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  box-shadow:\r\n    0 4px 6px rgba(0, 0, 0, 0.25),\r\n    0 20px 60px rgba(0, 0, 0, 0.6);\r\n  width: 100%;\r\n  max-height: calc(100vh - 2rem);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  animation: am-slide-in 0.2s cubic-bezier(0.34, 1.10, 0.64, 1);\r\n}\r\n\r\n@keyframes am-slide-in {\r\n  from { transform: translateY(-18px) scale(0.97); opacity: 0; }\r\n  to   { transform: translateY(0)     scale(1);    opacity: 1; }\r\n}\r\n\r\n/* Sizes */\r\n.am-dialog--sm { max-width: 480px; }\r\n.am-dialog--md { max-width: 640px; }\r\n.am-dialog--lg { max-width: 860px; }\r\n.am-dialog--xl { max-width: 1080px; }\r\n\r\n/* ── Header ──────────────────────────────────────────────────────────────── */\r\n.am-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1rem 1.25rem 1rem 1.5rem;\r\n  background: linear-gradient(120deg, #1e1b4b 0%, #312e81 60%, #4338ca 100%);\r\n  flex-shrink: 0;\r\n  gap: 0.75rem;\r\n  border-bottom: 1px solid var(--slate-300);\r\n}\r\n\r\n.am-header-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n  min-width: 0;\r\n}\r\n\r\n.am-title {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #f0f6ff;\r\n  letter-spacing: 0.01em;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.am-subtitle {\r\n  margin: 0;\r\n  font-size: 0.78rem;\r\n  color: rgba(210, 230, 255, 0.75);\r\n  line-height: 1.2;\r\n}\r\n\r\n.am-close {\r\n  flex-shrink: 0;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n  border-radius: 8px;\r\n  color: rgba(255, 255, 255, 0.8);\r\n  cursor: pointer;\r\n  width: 34px;\r\n  height: 34px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.15s, color 0.15s;\r\n  padding: 0;\r\n}\r\n\r\n.am-close:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: #ffffff;\r\n}\r\n\r\n/* ── Body ────────────────────────────────────────────────────────────────── */\r\n.am-body {\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* ── Footer ──────────────────────────────────────────────────────────────── */\r\n.am-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 0.6rem;\r\n  padding: 1rem 1.5rem;\r\n  border-top: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Form grid helper (use inside am-body) ──────────────────────────────── */\r\n.am-form-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.85rem;\r\n}\r\n\r\n.am-form-grid--1 { grid-template-columns: 1fr; }\r\n.am-form-grid--3 { grid-template-columns: 1fr 1fr 1fr; }\r\n.am-col-full     { grid-column: 1 / -1; }\r\n\r\n.am-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.am-label {\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  letter-spacing: 0.01em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.am-label .required { color: #dc3545; margin-left: 2px; }\r\n\r\n.am-input,\r\n.am-select,\r\n.am-textarea {\r\n  width: 100%;\r\n  padding: 0.5rem 0.75rem;\r\n  border: 1.5px solid var(--slate-300);\r\n  border-radius: 7px;\r\n  font-size: 0.9rem;\r\n  font-family: inherit;\r\n  color: var(--text-primary);\r\n  background: var(--bg-input);\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.am-input:focus,\r\n.am-select:focus,\r\n.am-textarea:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2);\r\n}\r\n\r\n.am-input::placeholder { color: var(--text-muted); }\r\n\r\n.am-textarea { resize: vertical; min-height: 72px; }\r\n\r\n/* Section divider inside form */\r\n.am-section {\r\n  grid-column: 1 / -1;\r\n  padding: 0.5rem 0 0.25rem;\r\n  margin-top: 0.25rem;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.am-section-title {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Action buttons (use in am-footer) ──────────────────────────────────── */\r\n.am-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.5rem 1.1rem;\r\n  border: none;\r\n  border-radius: 7px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s, transform 0.1s;\r\n  letter-spacing: 0.01em;\r\n}\r\n\r\n.am-btn:active  { transform: scale(0.97); }\r\n.am-btn:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }\r\n\r\n.am-btn-primary {\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\r\n  color: #fff;\r\n  box-shadow: 0 2px 8px rgba(var(--accent-rgb),.3);\r\n}\r\n.am-btn-primary:hover:not(:disabled) { background: linear-gradient(135deg, var(--accent-l), var(--accent)); }\r\n\r\n.am-btn-secondary {\r\n  background: var(--bg-input);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--slate-300);\r\n}\r\n.am-btn-secondary:hover:not(:disabled) { background: var(--slate-300); color: var(--text-primary); }\r\n\r\n.am-btn-danger {\r\n  background: #dc3545;\r\n  color: #fff;\r\n}\r\n.am-btn-danger:hover:not(:disabled) { background: #c82333; }\r\n\r\n/* Alert inside modal */\r\n.am-alert {\r\n  padding: 0.7rem 1rem;\r\n  border-radius: 7px;\r\n  font-size: 0.88rem;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n}\r\n.am-alert-danger  { background: rgba(220,38,38,.1); border: 1px solid rgba(220,38,38,.25); color: #f87171; }\r\n.am-alert-warning { background: rgba(245,158,11,.08); border: 1px solid rgba(245,158,11,.2); color: #fcd34d; }\r\n.am-alert-info    { background: rgba(var(--accent-rgb),.1); border: 1px solid rgba(var(--accent-rgb),.25); color: #a5b4fc; }\r\n\r\n/* ── Responsive ──────────────────────────────────────────────────────────── */\r\n@media (max-width: 600px) {\r\n  .am-dialog { border-radius: 10px 10px 0 0; }\r\n  .am-overlay { align-items: flex-end; padding: 0; }\r\n  .am-dialog--sm,\r\n  .am-dialog--md,\r\n  .am-dialog--lg,\r\n  .am-dialog--xl { max-width: 100%; }\r\n  .am-form-grid { grid-template-columns: 1fr; }\r\n  .am-form-grid--3 { grid-template-columns: 1fr 1fr; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
